import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SUB_CATEGORY_META, SUB_CATEGORY_META_SUCCESS, SUB_CATEGORY_META_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* subCategoryMeta({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/sub-categories/validate`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {

      yield put({
        type: SUB_CATEGORY_META_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SUB_CATEGORY_META_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUB_CATEGORY_META_ERROR, payload: error });
  }
}

export function* watchSubCategoryMeta() {
  yield takeEvery(SUB_CATEGORY_META, subCategoryMeta);
}

function* subCategoryMetaSaga() {
  yield all([fork(watchSubCategoryMeta)]);
}

export default subCategoryMetaSaga;
